import { DIRECTION_NAME } from "../../../constants";

export const onSubmitWithOppositeSplit = async (props, PAYMENTTYPE, INVOICETYPE) => {
    const { passengers, directionType } = props;

    const hasOpposite = passengers.length > 1 && passengers.some(p => p.haveOppositeDirection);

    if (!hasOpposite) {
        return {
            ...props,
            passengers,
            passengersCount: passengers.length,
            directionType,
            PAYMENTTYPE,
            INVOICETYPE
        };
    }

    const passengersSame = passengers.filter(p => !p.haveOppositeDirection);
    const passengersOpposite = passengers.filter(p => p.haveOppositeDirection);

    const reversedDirection =
        directionType === DIRECTION_NAME[0] ? DIRECTION_NAME[1] : DIRECTION_NAME[0];

    return {
        ...props,
        passengers: passengersSame,
        passengersCount: passengersSame.length,
        directionType,
        passengersOpposite,
        passengersOppositeCount: passengersOpposite.length,
        directionTypeOpposite: reversedDirection,
        PAYMENTTYPE,
        INVOICETYPE
    };
};
